import React from 'react';

const EnergyCertificateGradeB = props => (
  <svg width="150" height="34" viewBox="0 0 150 34" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M0 0.657375V33.1366H132.989L149.357 16.7694L132.989 0.657375H0Z" fill="#5DA436" />
    <path
      d="M110.746 24.4533H117.142C119.681 24.4533 121.141 23.3415 121.141 20.8028C121.141 18.6122 119.263 17.7788 117.386 17.7788H110.746V24.4533ZM110.746 13.5715H116.866C118.915 13.5715 120.549 12.7729 120.549 10.7911C120.549 8.7396 119.089 8.11507 116.726 8.11507H110.746V13.5715ZM105.74 3.80336H117.873C123.991 3.80336 125.557 7.62783 125.557 10.1994C125.557 13.7803 123.54 14.7896 122.496 15.3097C125.557 16.4582 126.355 18.8906 126.355 21.3597C126.355 23.3415 125.522 25.219 124.2 26.5048C122.775 27.895 121.419 28.765 116.309 28.765H105.74V3.80336Z"
      fill="white"
    />
  </svg>
);

export default EnergyCertificateGradeB;
